// Turns Upcart's shipping protection ("Versicherter Versand") on by default.
// Upcart stores the customer's choice in the cart attribute beamAddonDesiredState_<variant>
// ("added" / "removed"); once the customer switches it off it stays off for that cart.
(() => {
  const variantId = Number(window.insuredShippingVariantId);
  if (!variantId || window.__insuredShippingDefault) return;
  window.__insuredShippingDefault = true;

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  const stateKey = `beamAddonDesiredState_${variantId}`;
  const originalFetch = window.fetch.bind(window);
  let busy = false;
  let queued = false;

  const post = (path, body) =>
    originalFetch(`${root}${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    });

  async function check() {
    if (busy) {
      queued = true;
      return;
    }
    busy = true;

    try {
      const cart = await originalFetch(`${root}cart.js`).then((r) => r.json());
      const insured = cart.items.some((item) => item.variant_id === variantId);
      const hasProducts = cart.items.some((item) => item.variant_id !== variantId);
      const choice = cart.attributes && cart.attributes[stateKey];
      let changed = false;

      if (hasProducts && !insured && choice !== "removed") {
        await post("cart/add.js", {
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: { __upcartAddon: variantId, __upcartShippingProtection: true },
            },
          ],
        });
        await post("cart/update.js", { attributes: { [stateKey]: "added" } });
        changed = true;
      } else if (!hasProducts && insured) {
        // Don't leave the insurance alone in an otherwise empty cart.
        await post("cart/change.js", { id: String(variantId), quantity: 0 });
        changed = true;
      }

      if (changed && typeof window.upcartRefreshCart === "function") window.upcartRefreshCart();
    } catch (e) {
      console.error(e);
    } finally {
      busy = false;
      if (queued) {
        queued = false;
        setTimeout(check, 300);
      }
    }
  }

  const isCartChange = (url) => /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url));

  window.fetch = function (input, init) {
    const url = typeof input === "string" ? input : input && input.url;
    const request = originalFetch(input, init);
    if (isCartChange(url)) request.then(() => setTimeout(check, 300)).catch(() => {});
    return request;
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartChange(url)) this.addEventListener("loadend", () => setTimeout(check, 300));
    return originalOpen.apply(this, arguments);
  };

  // Upcart also changes the cart through its own client; its hooks tell us when.
  ["upcartOnCartLoaded", "upcartOnCartUpdated", "upcartOnAddToCart"].forEach((name) => {
    const previous = window[name];
    window[name] = function () {
      setTimeout(check, 300);
      if (typeof previous === "function") return previous.apply(this, arguments);
    };
  });

  check();
})();
